import ApiService from '../api.services';

const PostOfficeService = {
  zipcode: async function (zipcode) {
    try {
      const response = await ApiService.get(
        `/api/postoffice/zipcode/${zipcode}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  address: async function (state, city, address) {
    try {
      const response = await ApiService.get(
        `/api/postoffice/address/${state}/${city}/${address}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  customer: async function (id, card, user, password) {
    try {
      const data = {
        data: {
          id,
          card,
          user,
          password,
        },
      };
      const response = await ApiService.post(`/api/postoffice/customer`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  lockObject: async function (idTag) {
    try {
      const data = {
        data: {
          idTag,
        },
      };
      const response = await ApiService.post(
        `/api/postoffice/lockObject`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  event: async function (tag, event, description) {
    try {
      const data = {
        tag, event, description
      };
      const response = await ApiService.post(
        `/api/postofficeobject/event`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/postofficeobject/event/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default PostOfficeService;

export { PostOfficeService };

